/**
 * CierreRespuesta — lo que va al pie de la última respuesta (2026-10-01).
 *
 * Las dos puertas: seguir con este cliente o empezar con otro. Las acciones sobre el producto
 * (AccionesProducto) van dentro de la tarjeta desde el 21-oct ("la decisión primero"); acá quedan
 * solo si la tarjeta no está a la vista (conAcciones). Osvaldo (Hipermaxi, 12-oct) pidió sacar
 * "no le hizo efecto" (se puede escribir igual).
 */
import type { ProductCard } from '../types/product_card'
import type { AccionCaso } from '../api/accion'
import { AccionesProducto } from './AccionesProducto'

interface Props {
  card?: ProductCard
  perfil: string | null
  ocupado: boolean
  onAccion: (accion: AccionCaso, extra?: { forma?: string; peso_kg?: number }) => void
  onPreguntar: (texto: string) => void
  onOtraConsulta: () => void
  onNuevoCliente: () => void
  /** Las acciones del producto acá abajo (cuando no están dentro de la tarjeta). */
  conAcciones?: boolean
}

export function CierreRespuesta({ card, perfil, ocupado, onAccion, onOtraConsulta, onNuevoCliente,
  conAcciones = true }: Props) {
  return (
    <div className="cierre" aria-label="Qué sigue">
      {conAcciones && <AccionesProducto card={card} perfil={perfil} ocupado={ocupado} onAccion={onAccion} />}
      <div className="cierre-puertas">
        <button type="button" className="puerta" disabled={ocupado} onClick={onOtraConsulta}
          aria-label="Otra consulta para este cliente">
          Otra consulta<span className="puerta-largo"> para este cliente</span>
        </button>
        <button type="button" className="puerta puerta-nuevo" disabled={ocupado} onClick={onNuevoCliente}>
          Nuevo cliente →
        </button>
      </div>
    </div>
  )
}
